import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Adjust path as needed
import { createLogger } from '../../utils/logger';

const logger = createLogger('AdminRoute');

function AdminRoute() {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    // You might want to show a loading spinner here
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    // Not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }

  if (userRole !== 'Admin') {
    // Logged in but not an Admin, redirect to home or an unauthorized page
    // For now, redirecting to home page
    logger.warn('User is not an admin', { userRole });
    return <Navigate to="/" replace />;
  }

  // User is authenticated and is an Admin, render the child route (AdminDashboard)
  return <Outlet />;
}

export default AdminRoute;
